import React from 'react'
import Seo from '../Seo/Seo'
import { LuAward, LuLayers, LuPhone, LuMail } from 'react-icons/lu'

const programs = [
  'Cloud Computing',
  'Mainframe Computing',
  'Business Analytics',
  'Telecom Informatics',
  'Open Source and Open Standards',
  'IT Infrastructure',
  'BFSI, Graphics, and Gaming',
  'Cyber Security',
  'Mobile Computing and IoT',
]

const College = () => {
  return (
    <>
      <Seo
        title='For Colleges | Industry-aligned certification programs | CLI'
        description='Partner with CLI to run industry-aligned 4-year parallel and 1-year certificate programs alongside B.Tech, and track student employability with the PLeX score.'
        path='/college'
      />
      <header className='page_hero'>
        <span className='home_eyebrow'>For colleges</span>
        <h1>Industry alignment that brings students closer to jobs</h1>
        <p className='home_lead'>
          As changes in the industry outpace curriculum updates, the gap between what industry needs and what students learn has to be filled.
        </p>
      </header>

      <div className='page_body'>
        <div className='bento'>
          <div className='bento_card span-4 tone-soft'>
            <h3 className='bento_title'>Industry priorities, inside your curriculum</h3>
            <p className='bento_para'>By collaborating with MindMatrix Labs, colleges incorporate the priorities of the industry through specialized industry-aligned programs.</p>
          </div>
          <div className='bento_card'>
            <h3 className='bento_title'>Skills beyond technology</h3>
            <p className='bento_para'>Students gain access to technological advancements, domain knowledge and industry best practices, and build critical thinking, teamwork, analytical reasoning and research skills.</p>
          </div>
        </div>

        <section className='page_section'>
          <span className='home_eyebrow'>How can we help</span>
          <h2 className='home_heading'>Pioneers in industry-aligned programs</h2>
          <p className='home_lead'>Our certification programs run in parallel with the existing B.Tech courses. Graduating students are awarded certificates from the industry partner in addition to the ones they get from the university.</p>
        </section>

        <section className='page_section'>
          <span className='home_eyebrow'>Programs offered</span>
          <div className='bento' style={{ marginTop: 0 }}>
            <div className='bento_card span-3 tone-brand'>
              <LuLayers className='bento_icon' />
              <h3 className='bento_title'>The 4-year Parallel Program</h3>
              <p className='bento_para'>Our Extended Certification Parallel Program runs alongside the B.Tech curriculum. Students from all specializations can join as an optional course, and our industry partner awards the certificate on successful completion.</p>
            </div>
            <div className='bento_card span-3'>
              <LuAward className='bento_icon' />
              <h3 className='bento_title'>The 1-year Short-Term Certificate Program</h3>
              <p className='bento_para'>Students gain an essential understanding of the core concepts through a structure similar to the 4-year program. The certificate is awarded upon successful completion.</p>
            </div>
          </div>
          <ul className='tag_list'>
            {programs.map((p) => <li key={p}>{p}</li>)}
          </ul>
        </section>

        <section className='page_section'>
          <span className='home_eyebrow'>PLeX Score</span>
          <h2 className='home_heading'>The employability index</h2>
          <p className='home_lead'>MindMatrix has developed a patented method of tracking and improving the knowledge and key industry-needed skills of students. The PLeX score indicates a student's fitment for the types of jobs offered by the industry.</p>
        </section>

        <section className='bento_card span-6 tone-brand' style={{ marginTop: 'clamp(40px, 6vw, 72px)', padding: 'clamp(28px, 5vw, 48px)' }}>
          <h2 className='home_heading' style={{ color: '#fff' }}>Enhanced education can be your choice today</h2>
          <p className='bento_para' style={{ marginTop: 12 }}>Connect with our team today and find out how.</p>
          <div className='cta_row'>
            <a className='btn btn_light' href='tel:+919611546444'><LuPhone /> +91 96115 46444</a>
            <a className='btn btn_light' href='mailto:contact@mindmatrix.io'><LuMail /> contact@mindmatrix.io</a>
          </div>
        </section>
      </div>
    </>
  )
}

export default College
